import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { HuntComponent } from './hunt/hunt.component';




const routes: Routes = [
  {path: '', component: HomeComponent},
  {path: 'hunt', component: HuntComponent},
  { path: '**', component: HomeComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }